import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, createForm, Form } from 'store/data/forms';

export function useCreateForm(): Operation<(form: Form) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.CREATE_FORM);

	async function handler(form: Form) {
		if (loading) return;
		if (error) resetError();

		await dispatch(createForm(form));
	}

	return [{ loading, error }, handler];
}
